export default __webpack_public_path__ + "static/stellar-e06646500232a3ecf39454684c6b80b7.gif";